import { MouseEvent, useCallback, useEffect, useRef, useState } from "react";

import { hasValue } from "@repo/helpers";

import DropdownMarkup from "./markup";
import { Props } from "./types";

export default function Dropdown(props: Props) {
	const stop = useRef(false);
	const dropdownRef = useRef<HTMLDivElement>();

	const [visible, setVisible] = useState(false);

	useEffect(() => {
		document.addEventListener("click", closeDropdown);
		return () => document.removeEventListener("click", closeDropdown);
	}, []);

	useEffect(() => {
		if (visible && hasValue(dropdownRef.current)) {
			const rect = dropdownRef.current.getBoundingClientRect();
			if (
				rect.left <= (window.innerWidth || document.documentElement.clientWidth) &&
				rect.right >= (window.innerWidth || document.documentElement.clientWidth)
			)
				dropdownRef.current.style.left =
					(window.innerWidth || document.documentElement.clientWidth) - rect.right - 10 + "px";
			else if (rect.right >= 0 && rect.left <= 0) dropdownRef.current.style.left = "0px";
		}
	});

	useEffect(() => {
		toggleCallback();
	}, [visible]);

	const toggleDropdown = useCallback(() => setVisible(!visible), [setVisible, visible]);

	const dropdownClicked = useCallback(
		function () {
			stop.current = true;
			if (props.closeOnClick || props.openOnHover) {
				toggleDropdown();
			}
		},
		[toggleDropdown, props.closeOnClick, props.openOnHover],
	);

	const closeDropdown = useCallback(
		function () {
			if (!visible) return;
			if (stop.current) {
				stop.current = false;
				return;
			}
			toggleDropdown();
		},
		[visible, toggleDropdown],
	);

	const toggleDropdownEvent = useCallback(
		function (event: MouseEvent<Element>) {
			stop.current = true;
			toggleDropdown();
		},
		[toggleDropdown],
	);

	function toggleCallback() {
		if (visible && props.onOpen) {
			props.onOpen();
		} else if (!visible && props.onClose) {
			props.onClose();
		} else if (props.onToggle) {
			props.onToggle(visible);
		}
	}

	return (
		<DropdownMarkup
			{...props}
			toggleDropdown={toggleDropdownEvent}
			dropdownRef={dropdownRef}
			dropdownClicked={dropdownClicked}
			visible={visible}
		/>
	);
}
